import { CircularProgress, Typography } from "@suraasa/placebo-ui"
import { lazy, Suspense, useEffect } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { BROWSER_STORAGE_KEYS } from "utils/constants"
import { UserPreferenceManager } from "utils/userPreferenceManager"

import AgreementCheckBox from "../AgreementCheckBox"
import {
  currentStepTitle,
  DSB_AGREEMENT_PDF_URL,
  OnboardingStepId,
} from "../constants"
import SignatureField from "../SignatureField"

/**
 * This sheet mounts on every authenticated page load, but only DSB learners
 * ever reach this document. Keeping pdf.js behind a lazy boundary keeps it out
 * of everyone else's bundle.
 */
const PDFDocument = lazy(() => import("../PDFDocument"))

const TDC_DSBAgreement = ({ onLoaded }: { onLoaded: () => void }) => {
  const form = useFormContext()

  useEffect(() => {
    UserPreferenceManager.set(BROWSER_STORAGE_KEYS.tdc_dsbAgreementSeen, "true")
  }, [])

  return (
    <div className="h-auto min-h-full pb-5">
      <Typography variant="title1" className="mb-2 mt-4">
        {currentStepTitle[OnboardingStepId.tdc_dsbAgreement]}
      </Typography>

      <Suspense
        fallback={
          <div className="grid place-items-center py-6">
            <CircularProgress color="black" size="lg" />
          </div>
        }
      >
        <PDFDocument url={DSB_AGREEMENT_PDF_URL} onLoaded={onLoaded} />
      </Suspense>

      <div className="mt-3 flex flex-col gap-2">
        <SignatureField />
        <Controller
          key="tdc_dsbAgreement"
          control={form.control}
          name="tdc_dsbAgreement"
          render={({ field, fieldState: { error } }) => (
            <AgreementCheckBox
              onChange={field.onChange}
              ref={field.ref}
              value={field.value}
              errorMessage={error?.message}
              title="I have read the above agreement and understand my moral obligations and responsibilities."
            />
          )}
        />
      </div>
    </div>
  )
}

export default TDC_DSBAgreement
